import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-piggy-bank" }, null, -1)

import { computed, ref, watch } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";

interface Props {
  modelValue?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
  status?: "" | "error" | "warning";
  minLength?: number;
  maxLength?: number;
  /** Group digits: #### #### #### */
  grouped?: boolean;
  validateOnBlur?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BankAccountInput',
  props: {
    modelValue: { default: "" },
    placeholder: { default: "Nhập số tài khoản ngân hàng" },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    allowClear: { type: Boolean, default: true },
    status: { default: "" },
    minLength: { default: 6 },
    maxLength: { default: 20 },
    grouped: { type: Boolean, default: true },
    validateOnBlur: { type: Boolean, default: true }
  },
  emits: ["update:modelValue", "change", "blur", "pressEnter", "validate"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const displayValue = ref("");

const onlyDigits = (value: string) =>
  value.replace(/\D/g, "").slice(0, props.maxLength);

const formatGrouped = (digits: string) =>
  props.grouped ? digits.replace(/(.{4})/g, "$1 ").trim() : digits;

const isValid = (digits: string) => {
  if (!digits) return true;
  return digits.length >= props.minLength && digits.length <= props.maxLength;
};

watch(
  () => props.modelValue,
  (val) => {
    displayValue.value = formatGrouped(onlyDigits(val ?? ""));
  },
  { immediate: true }
);

const localError = computed(() => {
  if (!props.validateOnBlur) return false;
  const digits = onlyDigits(props.modelValue ?? "");
  return !!digits && !isValid(digits);
});

const computedStatus = computed(() => props.status || (localError.value ? "error" : ""));

const onInput = (val: string) => {
  const digits = onlyDigits(val);
  displayValue.value = formatGrouped(digits);
  emit("update:modelValue", digits);
  emit("change", digits);
};

const onBlur = (e: FocusEvent) => {
  emit("validate", isValid(onlyDigits(props.modelValue ?? "")));
  emit("blur", e);
};

const onPressEnter = (e: KeyboardEvent) => emit("pressEnter", e);

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createBlock(_component_a_input, {
    value: displayValue.value,
    "onUpdate:value": [
      _cache[0] || (_cache[0] = ($event: any) => ((displayValue).value = $event)),
      onInput
    ],
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    size: _ctx.size,
    "allow-clear": _ctx.allowClear,
    maxlength: _ctx.maxLength,
    status: computedStatus.value,
    class: "ant-bank-account-input",
    onBlur: onBlur,
    onPressEnter: onPressEnter
  }, {
    prefix: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["value", "placeholder", "disabled", "size", "allow-clear", "maxlength", "status"]))
}
}

})